/*
 * @Description:
 * @Author: doris_xu
 * @Date: 2023-03-31 16:45:24
 * @LastEditTime: 2025-08-01 13:28:57
 */
/* eslint-disable */
/* tslint:disable */

import banner1 from '../../images/banner1.png'
import banner2 from '../../images/banner2.png'
import banner3 from '../../images/banner3.png'
import banner4 from '../../images/banner4.png'
import requireBanner from '../../images/requireBg.png'

const Banner = () => {
  return (
    <div className="home-div-bannerContainer">
      {window.location.pathname == '/require' && <img src={requireBanner} />}
      {window.location.pathname == '/schedule' && <img src={banner1} />}
      {window.location.pathname == '/jury' && <img src={banner3} />}
      {window.location.pathname == '/trends' && <img src={banner4} />}
      {window.location.pathname == '/enter/enterprise' && <img src={banner2} />}
      {window.location.pathname == '/enter/college' && <img src={banner2} />}
      {/*<Carousel autoplay>
        <div>
          <img src={banner} />
        </div>
        <div>
          <img src={banner} />
        </div>
      </Carousel>*/}
    </div>
  )
}

export default Banner
